"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnsureUiProvider = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const services_1 = require("./services");
const UiProvider_1 = require("./UiProvider");
const EnsureUiProvider = (props) => {
    const existing = React.useContext(services_1.context);
    if (existing)
        return React.createElement(React.Fragment, null, props.children);
    return React.createElement(UiProvider_1.UiProvider, { ...props });
};
exports.EnsureUiProvider = EnsureUiProvider;
